import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
import { OFFER_ANCHOR } from '../data/constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer = 0;
    const cycle = window.setInterval(() => {
      setVisible(true);
      showTimer = window.setTimeout(() => setVisible(false), 5500);
      setIndex(prev => (prev + 1) % purchases.length);
    }, 11000);
    const first = window.setTimeout(() => {
      setVisible(true);
      showTimer = window.setTimeout(() => setVisible(false), 5500);
    }, 4000);
    return () => {
      window.clearInterval(cycle);
      window.clearTimeout(first);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  const purchase = purchases[index];
  return <AnimatePresence data-id="element-190" data-mp="164obkbkmsdwt">
      {visible && !dismissed && <motion.aside initial={{
      opacity: 0,
      y: 14,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 14,
      scale: 0.97
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[268px] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border-2 border-gold bg-white shadow-2xl sm:w-[300px]" aria-live="polite" data-id="element-191" data-mp="1175z4b7engk2">
          <div className="flex items-start gap-2.5 p-3" data-id="element-192" data-mp="i9lbf7gdmo11">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-petrol" data-id="element-193" data-mp="x5u7y18vun9r">
              <CheckCircle2Icon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-194" data-mp="s5ye2utwgc7x" />
            </span>
            <a href={OFFER_ANCHOR} className="min-w-0 flex-1" data-id="element-195" data-mp="28joki88hrckq">
              <p className="font-display text-[10px] font-extrabold uppercase tracking-widest text-gold" data-id="element-196" data-mp="28maro6rgzq2f">
                Achat vérifié
              </p>
              <p className="mt-0.5 text-[12px] font-semibold leading-snug text-graphite" data-id="element-197" data-mp="2anrv54sad8hf">
                {purchase.name} — {purchase.city}, France
              </p>
              <p className="text-[11px] leading-snug text-graphite/70" data-id="element-198" data-mp="2kn0p3xn5in3s">
                vient d’obtenir ORTHOPHONIE PRO™
              </p>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification" className="shrink-0 rounded p-0.5 text-graphite/40 transition-colors duration-150 ease-out hover:text-graphite" data-id="element-199" data-mp="2pl2fl3mwpopa">
              <XIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-200" data-mp="21uonjd4bnpup" />
            </button>
          </div>
          <div className="h-1 w-full bg-gold" data-id="element-201" data-mp="26oj0zytc38lc" />
        </motion.aside>}
    </AnimatePresence>;
}